import { useCallback } from 'react';

const useLocalStorage = <Type>(
  key: string
): [(value: Type) => void, () => Type | null, () => void] => {
  const storeValue = useCallback(
    (value: Type) => localStorage.setItem(key, JSON.stringify(value)),
    [key]
  );

  const retrieveValue = useCallback((): Type | null => {
    const jsonValue = localStorage.getItem(key);

    return jsonValue ? JSON.parse(jsonValue) : undefined;
  }, [key]);

  const removeValue = useCallback(
    (): void => localStorage.removeItem(key),
    [key]
  );

  return [storeValue, retrieveValue, removeValue];
};

export default useLocalStorage;
